import { getSupportedLocaleOptions } from '../locales/localeConfig';

export const LANGUAGE = [
	...getSupportedLocaleOptions().map(({ nativeLabel, locale }) => ({
		label: nativeLabel,
		value: locale,
	})),
];
